import { render } from "./AccountView.vue?vue&type=template&id=731645e0&scoped=true"
import script from "./AccountView.vue?vue&type=script&lang=js"
export * from "./AccountView.vue?vue&type=script&lang=js"

import "./AccountView.vue?vue&type=style&index=0&id=731645e0&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-731645e0"

export default script